import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Link, Navigate, Outlet, Route, Routes } from "react-router-dom";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { Toaster } from "@/components/ui/sonner";
import { AppHeader } from "@/components/docs/AppHeader";
import { DocSidebar } from "@/components/docs/DocSidebar";
import { DocsProvider } from "@/lib/DocsContext";
import { ThemeProvider, useThemeMode } from "@/lib/theme";
import OverviewPage from "@/pages/OverviewPage";
import DocPage from "@/pages/DocPage";
import ControlCenterRoute from "@/control/ControlCenterRoute";

const Layout = () => {
  const [open, setOpen] = useState(false);
  const { theme } = useThemeMode();
  return (
    <div className="min-h-screen bg-background text-foreground">
      <AppHeader onMenu={() => setOpen(true)} />
      <div className="flex">
        <aside className="sticky top-16 hidden h-[calc(100vh-4rem)] w-80 shrink-0 border-r border-border bg-sidebar lg:block">
          <DocSidebar />
        </aside>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetContent side="left" className="w-80 bg-sidebar p-0" data-testid="mobile-sidebar-sheet">
            <SheetTitle className="sr-only">Dokumenti</SheetTitle>
            <DocSidebar onNavigate={() => setOpen(false)} />
          </SheetContent>
        </Sheet>
        <main className="min-w-0 flex-1">
          <Outlet />
        </main>
      </div>
      <Toaster theme={theme} position="bottom-right" />
    </div>
  );
};

const NotFound = () => (
  <div className="px-6 py-24 text-center" data-testid="not-found-page">
    <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">404</p>
    <p className="mt-3 text-muted-foreground">Ova stranica ne postoji.</p>
    <Link to="/" className="mt-6 inline-block text-primary" data-testid="not-found-home-link">Natrag na pregled</Link>
  </div>
);

function App() {
  return (
    <ThemeProvider>
      <DocsProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<Navigate to="/control" replace />} />
              <Route path="documentation" element={<OverviewPage />} />
              <Route path="doc/*" element={<DocPage />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            {/*
              The Business OS Control Center is deliberately OUTSIDE the G0 viewer
              layout: it is an application, not a documentation page, and keeping it
              separate is what preserves the approved viewer untouched.
            */}
            <Route path="/control/*" element={<ControlCenterRoute />} />
          </Routes>
        </BrowserRouter>
      </DocsProvider>
    </ThemeProvider>
  );
}

export default App;
